import React from "react";

export const Page = ({ children }) => {
  return <div className="min-h-full flex-col bg-slate-50">{children}</div>;
};
